export const black = '#1d2528';
export const white = '#ffffff';

export const grayDark = '#455055';
export const gray = '#b7c6cc';
export const grayLight = '#f4f6f6';
export const grayRule = '#e1e3e5';
export const grayPreview = '#f5f5f5';

export const blueLight = 'rgba(24, 144, 255, 0.5)';
export const blue = '#1890ff';
export const blueDark = '#1274ce';

export const red = '#b71420';

// Colors subject to change
export const textLight = '#849298'; // This is not part of Tyler's color spectrum but used in studio
export const buttonPrimaryBackground = '#2374BB';
export const buttonPrimaryBackgroundHover = '#4093DB';

export const headerText = '#333333';
